import { arrayOfType } from '../../utils/util-functions';

export interface IAgentsResponse {
  callCenterAgents: IAgent[];
  siteAgents: IAgent[];
  accountAgents: IAgent[];
}

export interface IAgent {
  agentId: number;
  firstName: string;
  lastName: string;
  fullName?: string;
  isCallCenterAgent?: boolean;
}

export interface IUpdateAgentPayload {
  agentId: number;
  callDetailRecordId: number;
}

export interface IUpdateAgentResponse {
  message: string;
  result: boolean;
}

export class AgentModel implements IAgent {
  agentId: number = 0;
  firstName: string = '';
  lastName: string = '';
  fullName: string = '';

  constructor(data?: IAgent) {
    if (data) {
      this.agentId = data.agentId ?? this.agentId;
      this.firstName = data.firstName ?? this.firstName;
      this.lastName = data.lastName ?? this.lastName;
      this.fullName = `${data.firstName} ${data.lastName}`;
    }
  }
}

export class AgentsResponseModel implements IAgentsResponse {
  siteAgents: IAgent[] = [];
  accountAgents: IAgent[] = [];
  callCenterAgents: IAgent[] = [];

  constructor(data?: IAgentsResponse) {
    if (data) {
      this.siteAgents = arrayOfType<IAgent>(data?.siteAgents, AgentModel);
      this.accountAgents = arrayOfType<IAgent>(data?.accountAgents, AgentModel);
      this.callCenterAgents = arrayOfType<IAgent>(data?.callCenterAgents, AgentModel);
    }
  }
}
